import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Form,FormData } from '../data/form';
import { MessageHandlerService } from "../../services/message-handler.service"
import { EventEmitter } from '@angular/core';

@Injectable()
export class FormService extends FormData {

  emitter: EventEmitter<any> = new EventEmitter();
  api: string;
  apiForm: string;
  header: any;
  constructor(private http: HttpClient, private messageHandler: MessageHandlerService) {
    super();
    this.api = environment.apiUrl;
  }


  async deleteForm(id?) {
    try {
      let flyers = await this.http.delete(this.api + "form/" + (id || "")).toPromise();
      return flyers
    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }


  async createForm(data) {
    try {

      let response = await this.http.post(this.api + "form", data).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async getForms(pagination, filter, order) {
    console.log({ pagination, filter, order });
    try {
      let response = await this.http.post(this.api + "forms", { pagination, filter, order }).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async getForm(id: string) {
    try {

      let form = <Form>await this.http.get(this.api + "form/" + id).toPromise();
      return form

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }


  async duplicateForm(id: string) {
    try {

      let form = <Form>await this.http.get(this.api + "form/duplicate/" + id).toPromise();
      return form

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async editForm(data, id?: string) {
    try {

      let response = <Form>await this.http.put(this.api + "form/" + (id || ''), data).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

}
